import { t } from "@lingui/core/macro";
import { Stack, Typography } from "@mui/material";
import Section from "@/components/Section";
import { useBookingContext } from "@/contexts/BookingContext";

export default function CancellationTerms() {
  const { state } = useBookingContext();
  const cancellationTerms = state.price?.cancellation_terms || [];

  if (cancellationTerms.length === 0) {
    return null;
  }

  return (
    <Section title={t`Cancellation Policy`}>
      <Stack spacing={1}>
        {cancellationTerms.map((term) => (
          <Typography variant="body2" key={term}>
            {term}
          </Typography>
        ))}
      </Stack>
    </Section>
  );
}
